import { DefaultService } from '@/services/DefaultService';

export default class RelatorioLancamentosService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}


	find(id, isDespesa) {
		return this._http.get(`${this._env}/despesa/relatorio/lancamentos/${id}.json?isdespesa=${isDespesa}`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAll(page = 0, limit = 50, filter) {
        return this._http.post(`${this._env}/despesa/relatorio/lancamentos.json?page=${page}&limit=${limit}`, filter, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}

    /**
     * @70209 - implementado esse metodo para pegar o valor total das despesas.
     */
    getTotalValor(page = 0, limit = 50, filter) {
        return this._http.post(`${this._env}/despesa/relatorio/lancamentos/valortotal?page=${page}&limit=${limit}`, filter, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}

	findAllExport(filter) {
        let headCopy = { ...this._headers};
        headCopy.responseType = 'arraybuffer';
        return this._http.post(`${this._env}/despesa/relatorio/lancamentos/pdf`, filter, headCopy)
            .then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
	}
	filtroEmpresas(search) {
        return this._http.get(`${this._env}/despesa/relatorio/lancamentos/filtro/empresas.json?search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}
	filtroColaboradores(search) {
        return this._http.get(`${this._env}/despesa/relatorio/lancamentos/filtro/colaboradores.json?search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}
	filtroMotivoDespesas(search) {
        return this._http.get(`${this._env}/despesa/relatorio/lancamentos/filtro/motivodespesas.json?search=${search}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
	}
    
    getCSVReport(filtros) {
        return this._http.post(`${this._env}/despesa/relatorio/lancamentos/csv`, filtros, this._headers).then( res => res.body, this.handleError);
    }

}